export const version = 'v2.2.4-1976-g35dfbd54a'
